var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSelectIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81184 10.8619C6.07219 10.6015 6.4943 10.6015 6.75465 10.8619L8.94991 13.0572L11.1452 10.8619C11.4055 10.6015 11.8276 10.6015 12.088 10.8619C12.3483 11.1222 12.3483 11.5443 12.088 11.8047L9.42131 14.4714C9.16097 14.7317 8.73886 14.7317 8.47851 14.4714L5.81184 11.8047C5.55149 11.5443 5.55149 11.1222 5.81184 10.8619Z",
    fill: "#141F2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.47851 1.52864C8.73886 1.26829 9.16097 1.26829 9.42131 1.52864L12.088 4.1953C12.3483 4.45565 12.3483 4.87776 12.088 5.13811C11.8276 5.39846 11.4055 5.39846 11.1452 5.13811L8.94991 2.94285L6.75465 5.13811C6.4943 5.39846 6.07219 5.39846 5.81184 5.13811C5.55149 4.87776 5.55149 4.45565 5.81184 4.1953L8.47851 1.52864Z",
    fill: "#141F2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSelectIc);
export default __webpack_public_path__ + "static/media/arrow_select_ic.15a772d87a261b080ed13c585325ede7.svg";
export { ForwardRef as ReactComponent };